@if (subscription?.data) {
    <div>
        <div>
            <!-- Subscription logo -->
            <h3 class="title is-level-4">
                <span class="">{{ subscriptionLabel }}</span>
            </h3>
            <!-- Obligation -->
            @if (isLocked) {
                <p class="is-block is-size-6 has-text-weight-semibold">Forfait bloqué</p>
            }
        </div>
        @if (isFaimType) {
            <div class="columns is-multiline has-text-centered">
                <div class="column is-6">
                    <span class="icon is-huge">
                        <i class="tri-4g"></i>
                    </span>
                    <p>Réseau 4G/4G+</p>
                </div>
                <div class="column is-6">
                    <span class="icon is-huge">
                        <i class="tri-tv"></i>
                    </span>
                    <p>TV HD + 70 chaînes</p>
                </div>
            </div>
        }
        <!-- Simcard features -->
        <div class="columns has-text-left is-mobile mt-1">
            <div class="column is-narrow is-paddingless">
                <span class="icon is-large is-main icon-no-width">
                    @if (sim?.data?.type_id === 'qr_esim') {
                        <i class="tri-esim"></i>
                    } @else {
                        <i class="tri-sim-card"></i>
                    }
                </span>
            </div>
            <div class="column is-8-desktop">
                @if (showSimCard && sim?.data?.type_id !== 'qr_esim') {
                    <p class="text is-level-3 is-marginless">SIM triple découpe compatible tous mobiles</p>
                }
                <div class="mt-1">
                    <checkout-prices-block
                        [subscription]="subscription"
                        [subscriptionBlock]="true"
                        [promoAmount]="convergencePromoAmount + (!isConnected ? promoHome?.amount || 0 : 0)"
                    />
                    @if (canHaveConvergence && convergencePromoAmount > 0) {
                        <p class="text is-level-4">
                            Remise -{{ convergencePromoAmount }}€ /mois incluse pour les clients Bbox
                            {{ milanoPromo?.amount > 0 ? ' + mobile' : '' }}
                        </p>
                    }
                    @if (canHavePromoHome) {
                        <span class="sticker is-info is-small mt-1 mb-1">
                            {{ promoHome.fanion || '-{{ promoHome.amount }}€/mois déjà déduit' }}
                        </span>
                    }
                    <p class="text is-level-3">{{ subscription.data.obligation | obligationLabel }}</p>
                    @if (
                        !isConnected &&
                        !canHavePromoHome &&
                        !canHaveConvergence &&
                        milanoPromo?.amount > 0 &&
                        subscription?.prices?.final - milanoPromo?.amount > 0
                    ) {
                        <p class="text is-level-4 is-marginless">
                            Déjà client Bbox + mobile ? Vous profitez de ce forfait à
                            <trg-price
                                [price]="subscription?.prices?.final - milanoPromo?.amount"
                                [isInlined]="true"
                                [inheritFontSize]="true"
                                [hasPeriod]="true"
                            />
                            .
                        </p>
                    }
                </div>
            </div>
        </div>
    </div>
}
